import type { IconSvgObject } from './types';

const VariableIcon: IconSvgObject = [
  ["path", { d: "M10.5 13L12 14.5M12 14.5L13.5 16M12 14.5L13.5 13M12 14.5L10.5 16M16 11.5C16.6325 12.3628 17 13.3932 17 14.5C17 15.6068 16.6325 16.6372 16 17.5M8 11.5C7.36755 12.3628 7 13.3932 7 14.5C7 15.6068 7.36755 16.6372 8 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 8H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VariableIcon;
